module.exports = __webpack_public_path__ + "assets/img/23_134_big.8552fe95.jpg";